"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _i18n = require("@lce/i18n");

var _slice = require("@lce/slice");

var _api = require("@lce/api");

var _router = require("@reach/router");

var _useCart = _interopRequireDefault(require("../../useCart"));

var _Address = _interopRequireDefault(require("./Address"));

var _CartList = _interopRequireDefault(require("./CartList"));

var _ChangeAddress = _interopRequireDefault(require("./ChangeAddress"));

var _CheckoutButton = _interopRequireDefault(require("./CheckoutButton"));

var _MinimumSubtotalModal = _interopRequireDefault(require("./MinimumSubtotalModal"));

var _Subtotal = _interopRequireDefault(require("./Subtotal"));

var Styled = _interopRequireWildcard(require("./Cart.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/* eslint-disable react/forbid-component-props */
// eslint-disable-next-line max-lines-per-function
var Cart = function Cart(_a) {
  var onClose = _a.onClose;

  var _b = (0, _api.useOrder)(),
      order = _b.order,
      type = _b.type;

  var _c = (0, _useCart["default"])(),
      count = _c.count,
      subtotal = _c.subtotal;

  var deliveryAddress = (0, _api.useAddress)().deliveryAddress;

  var _d = (0, _i18n.useTranslation)(),
      t = _d.t,
      language = _d.i18n.language;

  var isDelivery = type === 'delivery';

  var _e = (0, _api.useCanStoreDeliver)({
    deliveryAddress: deliveryAddress && {
      city: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.city,
      state: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.state,
      street: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.street,
      zipCode: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.zipCode,
      unit: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.unit
    }
  }, order.locationNumber, isDelivery),
      canStoreDeliverData = _e.data,
      canStoreDeliverLoading = _e.isLoading,
      canStoreDeliverSuccess = _e.isSuccess;

  var _f = (0, _react.useState)(false),
      isMinimumWarningOpen = _f[0],
      setIsMinimumWarningOpen = _f[1];

  var _g = (0, _react.useState)(false),
      isCheckoutDisabled = _g[0],
      setIsCheckoutDisabled = _g[1];

  var locale = language;
  var minimumDeliveryThreshold = (canStoreDeliverData === null || canStoreDeliverData === void 0 ? void 0 : canStoreDeliverData.deliveryFees.minimumDeliveryThreshold) || 0;
  var hasDeliveryThreshold = minimumDeliveryThreshold > 0;
  var isUnderMinimum = subtotal < minimumDeliveryThreshold;
  var addressLabel = type === 'pickup' ? t('Header.Cart.Pickup Address Label') : t('Header.Cart.Delivery Address Label');
  var minimumMessage = "" + t('Header.Cart.DeliveryMinimumModal.Body.Pre') + minimumDeliveryThreshold + "\n    " + t('Header.Cart.DeliveryMinimumModal.Body.Post');
  (0, _react.useEffect)(function () {
    if (isDelivery) {
      if (canStoreDeliverLoading || !canStoreDeliverSuccess || !canStoreDeliverData) {
        setIsCheckoutDisabled(true);
      } else {
        setIsCheckoutDisabled(false);
      }
    }
  }, [canStoreDeliverLoading, canStoreDeliverSuccess, canStoreDeliverData]);

  var handleCheckout = function handleCheckout() {
    onClose();
    (0, _router.navigate)("/" + locale + "/order/" + type + "/stores/" + order.locationNumber + "/checkout");
  };

  var onCheckoutClick = function onCheckoutClick() {
    if (isDelivery && isUnderMinimum) {
      setIsMinimumWarningOpen(true);
    } else {
      handleCheckout();
    }
  };

  var handleOnClose = function handleOnClose() {
    if (order.locationNumber) {
      (0, _router.navigate)("/" + locale + "/order/" + type + "/stores/" + order.locationNumber + "/menu");
    }

    onClose();
  };

  return _react["default"].createElement(_slice.Flex, {
    flexDirection: "column",
    justifyContent: "space-between",
    p: 8,
    width: 1
  }, _react["default"].createElement(_slice.Box, null, _react["default"].createElement(_slice.Box, {
    mb: 6
  }, _react["default"].createElement(_slice.Flex, {
    alignItems: "center"
  }, _react["default"].createElement(Styled.AddressText, {
    as: "h2",
    "data-testid": "mini-cart__address-label",
    mb: 0,
    mr: 2
  }, addressLabel), _react["default"].createElement(_ChangeAddress["default"], {
    to: "/" + locale + "/order"
  }, t('Common.Change Link'))), _react["default"].createElement(_Address["default"], {
    type: type
  })), _react["default"].createElement(_CartList["default"], null), _react["default"].createElement(_Subtotal["default"], null)), _react["default"].createElement(_slice.Box, {
    style: {
      textAlign: 'center'
    }
  }, _react["default"].createElement(_CheckoutButton["default"], {
    count: count,
    disabled: isCheckoutDisabled,
    onClick: onCheckoutClick,
    t: t
  }), _react["default"].createElement(Styled.Close, {
    "aria-label": "Close",
    "data-testid": "mini-cart__close-cart",
    onClick: handleOnClose
  }, order.locationNumber ? t('Common.Back to Menu Link') : t('Common.Close')), hasDeliveryThreshold && _react["default"].createElement(_MinimumSubtotalModal["default"], {
    heading: t('Header.Cart.DeliveryMinimumModal.Heading'),
    isOpen: isMinimumWarningOpen,
    message: minimumMessage,
    onClose: function onClose() {
      return setIsMinimumWarningOpen(false);
    }
  })));
};

var _default = Cart;
exports["default"] = _default;